import type { HeroTitleBlock } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import PageHeadTertiary from '../template-blocks/PageHeadTertiary'

export const HeroTitleConverter: JSXConverter<SerializedBlockNode<HeroTitleBlock>> = ({ node }) => {
	return <PageHeadTertiary title={node.fields.title} />
}
